/**
 * The initial auth state.
 */
export const initialAuthState = {
  isInitialized: false,
  user: undefined,
  error: undefined,
  use_identity_login: false,
  use_frame: false,
}
